export default "__VITE_ASSET__C_Ir6BJP__"